import { observable, action, makeObservable } from 'mobx';
import agent from '../agent';
import commonStore from './commonStore';

class SkillsStore {
    constructor() {
        makeObservable(this, {
            currentList: observable,
            updatingErrors: observable,
            updating: observable,
            loading: observable,
            requestParams: observable,
            deleteSuccess: observable,
            lastListLoadTime: observable,
            resetLastListLoadTime: action,
            filters: observable,
            appliedFilters: observable,
            setFilter: action,
            onFilter: action,
            loadList: action,
            save: action,
            remove: action,
            getSkillsDetails: action,
            getSkillUserDetails: action
        });
    }

    currentList = [];

    updatingErrors = null;

    updating = false;

    loading = false;

    requestParams = null;

    deleteSuccess = false;

    lastListLoadTime = null;

    resetLastListLoadTime() {
        this.lastListLoadTime = new Date();
    }
    filters = {
        name: '',
    };

    appliedFilters = {
        name: '',
    };

    setFilter(name, value) {
        const filters = Object.assign({}, this.filters);
        filters[name] = value;
        this.filters = filters;
    }

    onFilter() {
        this.appliedFilters = Object.assign({}, this.filters);
    }

    loadList(params) {
        return agent.Skills.list(params)
            .then(
                action(list => {
                    this.requestParams = params;
                    list.time = new Date();
                    this.lastListLoadTime = list.time;
                    this.currentList = list;
                    return list.rows;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    save(values, isAdd) {
        this.updating = true;
        return agent.Skills.save(values, isAdd)
            .then(
                action(data => {
                    return data;
                })
            )
            .catch(
                action(err => {
                    this.updating = false;
                    this.updatingErrors = err.response && err.response.body && err.response.body.errors;
                    throw err;
                })
            );
    }

    getSkillsDetails(params = {}) {
        try {
            return agent.Skills.getSkillsDetails(params).then(
                action((response) => {
                    return response.skills;
                })
            ).catch(
                action(err => {
                    throw err
                })
            )
        } catch (err) {
            commonStore.addNotification(err.message, null, 'error');
        }
    }

    getSkillUserDetails(params = {}) {
        try {
            return agent.Skills.getSkillUserDetails(params).then(
                action((response) => {
                    return response.skillsList
                })
            ).catch(
                action(err => {
                    throw err
                })
            )
        } catch (err) {
            commonStore.addNotification(err.message, null, 'error');
        }
    }

    async remove(id) {
        await agent.Skills.remove(id);
        this.deleteSuccess = true;
        this.resetLastListLoadTime()
        return 1;
    }
}

const _SkillsStore = new SkillsStore();
export default _SkillsStore;